import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a0ac1c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-outline rounded-3 overflow-hidden" }
const _hoisted_2 = { class: "session-list w-100 d-none d-md-table" }
const _hoisted_3 = { class: "session-list__header fw-bold" }
const _hoisted_4 = { class: "align-baseline" }
const _hoisted_5 = { class: "session-list__header__title" }
const _hoisted_6 = { class: "session-list__header__title" }
const _hoisted_7 = { class: "session-list__header__title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "session-list__header__title" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "session-list__header__title" }
const _hoisted_12 = { class: "d-flex align-items-center me-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "session-list__header__title text-decoration-underline fw-bolder link-blue text-nowrap ms-3" }, " Join Meeting ", -1))
const _hoisted_14 = {
  key: 0,
  class: "session-list__loader"
}
const _hoisted_15 = {
  key: 1,
  class: "session-list__body"
}
const _hoisted_16 = {
  key: 2,
  class: "session-list__message"
}
const _hoisted_17 = { class: "d-block d-md-none" }
const _hoisted_18 = {
  key: 0,
  class: "session-list__loader"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

import PaginationBar from '@/components/PaginationBar'
import SessionListItem from '@/components/SessionListItem/SessionListItem.vue'
import SessionListMobileItem from '@/components/SessionListItem/SessionListMobileItem.vue'
import { SessionSortCriteria } from '../SessionRegistryStore'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import { MicroFilter } from '../SessionSearch/SessionSeach.interfaces'
import TableLoader from '@/components/TableLoader'
import ArrowUp from '@/icons/ArrowUp.vue'
import ArrowDown from '@/icons/ArrowDown.vue'
import ExpandArrows from '@/icons/ExpandArrows.vue'
import PersonCheckmark from '@/icons/PersonCheckmark.vue'
import VideoCamera from '@/icons/VideoCamera.vue'
import { Coach, CourseTag, WithId } from '@/types/api'
import { checkIsEmpty } from '@/utils/is-empty'
import { computePaginatedSessions, computeTotalSessionPages } from '@/utils/pagination'
import { filterByDayAndTime } from '@/utils/filter'


import { defineComponent, defineProps, defineEmits, ref, computed } from 'vue'
const __default__ = defineComponent({
  name: 'SessionList'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    sessions: {},
    searchCriteria: {},
    microFilter: {},
    isLoading: { type: Boolean },
    isLsat: { type: Boolean },
    isReady: { type: Boolean },
    disabled: { type: Boolean },
    coaches: {},
    courseTags: {},
    showRegisteredOnly: { type: Boolean }
  },
  emits: ['filtered-session-list-length-updated'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const sessionsPerPage = computed(() => sessionsExpanded.value ? 100000 : 8)
const currentPage = ref(1)
const filteredSessions = computed(computeFilteredSessions)
const totalSessionPages = computed(() => computeTotalSessionPages(filteredSessions.value, sessionsPerPage.value))
const paginatedSessions = computed(() => computePaginatedSessions(filteredSessions.value, sessionsPerPage.value, currentPage.value))
const sessionsExpanded = ref(false)
const isSortDescending = ref(true)
const sortCriteria = ref(SessionSortCriteria.Date)

function getInstructorName(coachId: string) {
  return props.coaches.find(c => c.id == coachId)?.name ?? ''
}

function getTagDetails(tags: string[]) {
  return props.courseTags.filter(courseTag => tags.some(tag => tag === courseTag.abbreviation))
}

function toggleSort(criteriaClicked: SessionSortCriteria) {
	if (criteriaClicked == sortCriteria.value)
	{
		isSortDescending.value = !isSortDescending.value
	}
	else
	{
		isSortDescending.value = true
	}
	sortCriteria.value = criteriaClicked
}

const firstIndex = computed(() => !paginatedSessions.value.length ? 0 : 1 + sessionsPerPage.value * (currentPage.value - 1))
const lastIndex = computed(() => !paginatedSessions.value.length ? 0 : firstIndex.value + paginatedSessions.value.length - 1)

const showMessage = computed(() => {
  return !paginatedSessions.value.length && props.isReady && !props.isLoading
})

const noSessionsMessage = computed(() => {
  return 'There are no available sessions' + (props.searchCriteria ? ' for your search criteria' : '')
})

function sessionExpand() {
  currentPage.value = 1
  sessionsExpanded.value = !sessionsExpanded.value
}

function computeFilteredSessions() {
  let filtered: SessionListItemViewModel[] = Array.from(props.sessions)
  filtered = filtered.filter((session) => session.localEndDateTime > new Date()) 
  
  if (!checkIsEmpty(props.searchCriteria)) {
    const upperCaseCriteria = props.searchCriteria.toUpperCase()

    filtered = filtered.filter((session) => {
      const upperCaseDate = session.localStartDateTime.toLocaleString('en-us', {weekday: 'long', month: 'short', day: 'numeric', year: 'numeric'}).toUpperCase()
      const upperCaseStartEndTime = session.localStartEndTime.toUpperCase()
      const upperCaseDateFullMonth = session.localStartDateTime.toLocaleString('en-us', {month: 'long', day: 'numeric', year: 'numeric'}).toUpperCase()
      const upperCaseTitle = session.event.title.toUpperCase()
      const upperCaseCoach = (getInstructorName(session.event.coachId)).toUpperCase()
      return (
        upperCaseDate.includes(upperCaseCriteria) ||
        upperCaseStartEndTime.includes(upperCaseCriteria) ||
        upperCaseDateFullMonth.includes(upperCaseCriteria) ||
        upperCaseTitle.includes(upperCaseCriteria) ||
        (upperCaseCoach.includes(upperCaseCriteria) && props.isLsat)
      )
    })
  }

  if (props.showRegisteredOnly ) {
    filtered = filtered.filter((session) => session.showRegistered)
  }
  
  filtered = filterByDayAndTime(filtered, props.microFilter)

  if (props.microFilter?.tags?.length) {
    filtered = filtered.filter((session) =>
      (session.tags ?? []).some(tag => props.microFilter.tags.includes(tag))
    )
  }

  if (sortCriteria.value == SessionSortCriteria.Date) {
    filtered.sort((leftElement, rightElement) => (leftElement.localStartDateTime.getTime() - rightElement.localStartDateTime.getTime()))
  }
  if (sortCriteria.value == SessionSortCriteria.Time) {
    filtered.sort((leftElement, rightElement) => ((leftElement.localStartDateTime.getHours() - rightElement.localStartDateTime.getHours()) * 60
        + (leftElement.localStartDateTime.getMinutes() - rightElement.localStartDateTime.getMinutes())))
  }
  if (sortCriteria.value == SessionSortCriteria.Title) {
      filtered.sort((leftElement, rightElement) => leftElement.event.title.localeCompare(rightElement.event.title))
  }
  if (sortCriteria.value == SessionSortCriteria.Instructor) {
    filtered.sort((leftElement, rightElement) => getInstructorName(leftElement.event.coachId).localeCompare(getInstructorName(rightElement.event.coachId)))
  }
  if (!isSortDescending.value) {
    filtered.reverse()
  }
  filtered.sort((leftElement, rightElement) => leftElement.showRegistered === rightElement.showRegistered ? 0 : (leftElement.showRegistered ? -1 : 1))
  currentPage.value = 1

  emit('filtered-session-list-length-updated', filtered.length)

  return filtered
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_4, [
            _createVNode(PersonCheckmark, { class: "ms-3" })
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": "sort by date",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSort(_unref(SessionSortCriteria).Date)))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(" Day/Date "),
                (sortCriteria.value !== _unref(SessionSortCriteria).Date)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ])
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": "sort by time",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort(_unref(SessionSortCriteria).Time)))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(" Time "),
                (sortCriteria.value !== _unref(SessionSortCriteria).Time)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ])
          ]),
          _createElementVNode("th", null, [
            _createElementVNode("button", {
              class: "session-list__header__sort-button",
              type: "button",
              "aria-label": "sort by title",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort(_unref(SessionSortCriteria).Title)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(" Title "),
                (sortCriteria.value !== _unref(SessionSortCriteria).Title)
                  ? (_openBlock(), _createBlock(ExpandArrows, {
                      key: 0,
                      class: "arrow-slot",
                      "aria-hidden": "true"
                    }))
                  : (isSortDescending.value)
                    ? (_openBlock(), _createBlock(ArrowDown, {
                        key: 1,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
                    : (_openBlock(), _createBlock(ArrowUp, {
                        key: 2,
                        class: "arrow-slot",
                        "aria-hidden": "true"
                      }))
              ])
            ])
          ]),
          (_ctx.isLsat)
            ? (_openBlock(), _createElementBlock("th", _hoisted_8, [
                _createElementVNode("button", {
                  class: "session-list__header__sort-button",
                  type: "button",
                  "aria-label": "sort by instructor",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSort(_unref(SessionSortCriteria).Instructor)))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(" Instructor "),
                    (sortCriteria.value !== _unref(SessionSortCriteria).Instructor)
                      ? (_openBlock(), _createBlock(ExpandArrows, {
                          key: 0,
                          class: "arrow-slot",
                          "aria-hidden": "true"
                        }))
                      : (isSortDescending.value)
                        ? (_openBlock(), _createBlock(ArrowDown, {
                            key: 1,
                            class: "arrow-slot",
                            "aria-hidden": "true"
                          }))
                        : (_openBlock(), _createBlock(ArrowUp, {
                            key: 2,
                            class: "arrow-slot",
                            "aria-hidden": "true"
                          }))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("th", _hoisted_10, [
                _createElementVNode("button", {
                  class: "session-list__header__sort-button",
                  type: "button",
                  "aria-label": "sort by availability",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSort(_unref(SessionSortCriteria).Availability)))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(" Availability "),
                    (sortCriteria.value !== _unref(SessionSortCriteria).Availability)
                      ? (_openBlock(), _createBlock(ExpandArrows, {
                          key: 0,
                          class: "arrow-slot",
                          "aria-hidden": "true"
                        }))
                      : (isSortDescending.value)
                        ? (_openBlock(), _createBlock(ArrowDown, {
                            key: 1,
                            class: "arrow-slot",
                            "aria-hidden": "true"
                          }))
                        : (_openBlock(), _createBlock(ArrowUp, {
                            key: 2,
                            class: "arrow-slot",
                            "aria-hidden": "true"
                          }))
                  ])
                ])
              ])),
          _createElementVNode("th", null, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(VideoCamera),
              _hoisted_13
            ])
          ])
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_unref(TableLoader))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedSessions.value, (event) => {
              return (_openBlock(), _createBlock(SessionListItem, {
                key: event.sessionId,
                "model-value": event,
                "instructor-name": getInstructorName(event.coachId),
                "event-tags": getTagDetails(event.tags),
                disabled: _ctx.disabled,
                "is-last-row": event == paginatedSessions.value[paginatedSessions.value.length-1],
                "is-lsat": _ctx.isLsat
              }, null, 8, ["model-value", "instructor-name", "event-tags", "disabled", "is-last-row", "is-lsat"]))
            }), 128))
          ])),
      (showMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(noSessionsMessage.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_unref(TableLoader))
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(paginatedSessions.value, (event) => {
            return (_openBlock(), _createBlock(SessionListMobileItem, {
              key: event.sessionId,
              "model-value": event,
              "instructor-name": getInstructorName(event.coachId),
              "event-tags": getTagDetails(event.tags),
              disabled: _ctx.disabled,
              "is-last-row": event == paginatedSessions.value[paginatedSessions.value.length-1],
              "is-lsat": _ctx.isLsat
            }, null, 8, ["model-value", "instructor-name", "event-tags", "disabled", "is-last-row", "is-lsat"]))
          }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['nav-footer fs-6 flex-column flex-md-row', {'nav-footer__no-pages': totalSessionPages.value <= 1}])
    }, [
      _createElementVNode("span", null, [
        _createTextVNode(" Showing " + _toDisplayString(firstIndex.value) + " - " + _toDisplayString(lastIndex.value) + " of " + _toDisplayString(filteredSessions.value.length) + " • ", 1),
        _createElementVNode("button", {
          class: "expand-btn",
          onClick: sessionExpand
        }, [
          (sessionsPerPage.value != 100000)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "View All"))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, "Collapse"))
        ])
      ]),
      _withDirectives(_createVNode(_unref(PaginationBar), {
        "pagination-value": currentPage.value,
        "onUpdate:paginationValue": _cache[5] || (_cache[5] = ($event: any) => ((currentPage).value = $event)),
        "total-pages": totalSessionPages.value,
        spread: 2,
        disabled: _ctx.disabled
      }, null, 8, ["pagination-value", "total-pages", "disabled"]), [
        [_vShow, totalSessionPages.value > 1]
      ])
    ], 2)
  ]))
}
}

})